var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-image-card"},[_c('div',[_c('img',{attrs:{"src":_vm.imgUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }